/**
 * @deprecated Scheduled for deletion in R-4 (resolver pipeline).
 * Mask patterns will be JSON metadata (`maskPattern`), unmask will be an `actionId` action.
 * Do NOT add new entries — use `maskPattern` in domain JSON instead.
 *
 * Active consumers: ViewField.tsx, domain/__tests__/masked-registry.test.ts.
 * Removal blocked until form-engine resolves maskPattern from JSON (R-4, Task 043+).
 */
import moment from 'moment';
import type { FieldDef } from '../primitives/types';
import type { MaskedFieldConfig } from '@packages/ui/patterns';
import { ParticipantService } from '@wealthlane/api-services/wealthlane-customer-service';
import * as temporal from '../primitives/temporal';
import * as identity from '../primitives/identity';
import { DATE_FORMAT } from '@/constants/common';

const registry = new Map<FieldDef, MaskedFieldConfig>([
  [
    temporal.dateOfBirth,
    {
      placeholder: 'xx/xx/xxxx',
      unmaskFn: (entityId) =>
        ParticipantService.getApiCustomerApiAppParticipantDateOfBirthByParticipantId(entityId),
      formatValue: (raw) => moment(raw).format(DATE_FORMAT),
    },
  ],
  [
    identity.ssn,
    {
      placeholder: 'xxxxxxxxx',
      unmaskFn: (entityId) =>
        ParticipantService.getApiCustomerApiAppParticipantSocialSecurityNumberByParticipantId(
          entityId,
        ),
    },
  ],
]);

export function getMaskedConfig(def: FieldDef): MaskedFieldConfig | undefined {
  return registry.get(def);
}
